import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'hmax-button-icon-small',
  standalone: true,
  templateUrl: './button-icon-small.component.html',
  styleUrls: ['./button-icon-small.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule, MatTooltipModule],
})
export class ButtonIconSmallComponent {
  @Input() icon = 'heroicons_outline:information-circle';
  @Input() tooltipText!: string;
  @Input() tooltipPosition: 'after' | 'before' | 'above' | 'below' | 'left' | 'right' = 'above';
}
